<template>
  <div class="new-layout-con">
    <router-view
      class="layout_main"
      :class="{
        'lead-theme':
          currentObj.type != 'index' &&
          ($route.path.includes('/list/risk') || $route.name == 'Contact'),
      }"
    ></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentObj: {}, //当前路由meta
    };
  },
  watch: {
    $route(to, from) {
      // 在这里处理路由变化时的逻辑
      this.currentObj = to.meta;
      let htmlDom = document.querySelector("html");
      let bodyDom = document.querySelector("body");
      if (bodyDom) {
        if (to.meta.isNewPage) {
          htmlDom.classList.add("html-new-page");
          bodyDom.className = this.currentObj.theme;
        } else {
          htmlDom.classList.remove("html-new-page");
          bodyDom.className = "";
        }
      }
    },
  },
  methods: {},
  mounted() {
    this.currentObj = this.$route.meta;
    let htmlDom = document.querySelector("html");
    let bodyDom = document.querySelector("body");
    if (htmlDom) {
      if (this.$route.meta.isNewPage) {
        htmlDom.classList.add("html-new-page");
        bodyDom.className = this.currentObj.theme;
      } else {
        htmlDom.classList.remove("html-new-page");
        bodyDom.className = "";
      }
    }

    console.log(this.$route.path);
    var arr=this.$route.path.split('/');

    for(var item of arr){
      if (this.$route.path.includes("sanction")) {
        this.$store.dispatch("app/setThemColor", "#f9722c");//juhuang
        break;
      }
      if (this.$route.path.includes("leads")) {
        this.$store.dispatch("app/setThemColor", "#8e86dd");//zi se
            break;
      }
      if (this.$route.path.includes("trade")) {
        this.$store.dispatch("app/setThemColor", "#009ea7");//lan lv
            break;
      }
      if (this.$route.path.includes("company") || this.$route.path.includes("account")) {
        this.$store.dispatch("app/setThemColor", "#1290c9");//lan se company
             break;
      }
      if (this.$route.path.includes("news")) {
        this.$store.dispatch("app/setThemColor", "#3ebb72");//lv se
            break;
      }
      if (this.$route.path.includes("riskScanning")) {
        this.$store.dispatch("app/setThemColor", "#1290c9");//lan se risk scan
            break;
      }
      if (this.$route.path.includes("ubo")) {
        this.$store.dispatch("app/setThemColor", "#603c2c");//ubo
             break;
      }
      if (this.$route.path.includes("dataServices")) {
        this.$store.dispatch("app/setThemColor", "rgb(185, 139, 115)");//dataServices
            break;
      }
    }
    

  },
};
</script>
